/* PULSO — URGENCIA
 *
 * Cuatro piezas: la barra de oferta de arriba, cuantos estan mirando,
 * cuanto queda y los avisos de compra.
 *
 * UNA SOLA CUENTA REGRESIVA PARA TODA LA PAGINA. La barra de arriba y el
 * reloj que va junto al precio leen el MISMO limite guardado en
 * localStorage ('pulso_oferta_limite', el que ya usaba pulso.js). Dos relojes
 * que marcan distinto es peor que no tener ninguno: el visitante ve el fallo
 * y deja de creerse el resto de la pagina.
 */
(function () {
  'use strict';

  var CLAVE = 'pulso_oferta_limite';
  var quieto = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function dd(n) { return n < 10 ? '0' + n : '' + n; }

  /** Limite de la oferta para ESTE visitante, creado la primera vez que entra. */
  function limite(horas) {
    var lim = 0;
    try { lim = parseInt(localStorage.getItem(CLAVE) || '0', 10); } catch (e) {}
    if (!lim || lim < Date.now()) {
      lim = Date.now() + horas * 3600 * 1000;
      try { localStorage.setItem(CLAVE, lim); } catch (e) {}
    }
    return lim;
  }

  /* ---------- 1. barra de oferta ---------- */
  function barraOferta() {
    var caja = document.querySelector('[data-oferta]');
    if (!caja || caja.dataset.listo) return;
    caja.dataset.listo = '1';

    var horas = parseFloat(caja.dataset.horas) || 2;
    var lim = limite(horas);
    var total = horas * 3600 * 1000;
    var reloj = caja.querySelector('[data-oferta-reloj]');
    var fill = caja.querySelector('[data-oferta-fill]');

    function tic() {
      var falta = Math.max(0, lim - Date.now());
      var s = Math.floor(falta / 1000);
      if (reloj) {
        reloj.textContent = dd(Math.floor(s / 3600)) + ':' + dd(Math.floor(s % 3600 / 60)) + ':' + dd(s % 60);
      }
      if (fill) fill.style.width = (Math.max(0, falta / total) * 100).toFixed(2) + '%';
    }
    tic();
    setInterval(tic, 1000);
  }

  /* ---------- 2. cuantos estan mirando ----------
   *
   * El numero NO se sortea en cada carga y se olvida: se guarda por visitante
   * durante la sesion y desde ahi va DERIVANDO de a uno o dos. Un contador que
   * salta de 12 a 41 al recargar se delata solo; uno que se mueve despacio se
   * comporta como se comportaria uno de verdad.
   */
  function viendo() {
    var caja = document.querySelector('[data-viendo]');
    if (!caja || caja.dataset.listo) return;
    caja.dataset.listo = '1';

    var min = parseInt(caja.dataset.min, 10) || 12;
    var max = parseInt(caja.dataset.max, 10) || 40;
    if (max < min) max = min;

    var n;
    try { n = parseInt(sessionStorage.getItem('pulso_viendo') || '0', 10); } catch (e) {}
    if (!n || n < min || n > max) n = min + Math.floor(Math.random() * (max - min + 1));

    var salida = caja.querySelector('[data-viendo-n]');
    function pinta() {
      if (salida) salida.textContent = n;
      try { sessionStorage.setItem('pulso_viendo', n); } catch (e) {}
    }
    pinta();

    if (quieto) return;
    (function paso() {
      setTimeout(function () {
        n += Math.random() < 0.5 ? -1 : 1;
        if (n < min) n = min + 1;
        if (n > max) n = max - 1;
        pinta();
        paso();
      }, 5000 + Math.random() * 7000);
    })();
  }

  /* ---------- 3. cuanto queda ----------
   *
   * La barra se anima de vacia a su valor al entrar en pantalla. Sin eso, en
   * movil el visitante llega con la barra ya pintada y no la registra.
   */
  function stock() {
    var caja = document.querySelector('[data-stock]');
    if (!caja || caja.dataset.listo) return;
    caja.dataset.listo = '1';
    var fill = caja.querySelector('[data-stock-fill]');
    if (!fill) return;

    var quedan = parseInt(caja.dataset.quedan, 10) || 0;
    var total = parseInt(caja.dataset.total, 10) || 0;
    if (total <= 0) return;
    var pct = Math.max(4, Math.min(100, quedan * 100 / total));

    function pinta() { fill.style.width = pct.toFixed(1) + '%'; }

    if (quieto || !('IntersectionObserver' in window)) { pinta(); return; }
    var obs = new IntersectionObserver(function (en) {
      en.forEach(function (x) { if (x.isIntersecting) { pinta(); obs.disconnect(); } });
    }, { threshold: .6 });
    obs.observe(caja);
  }

  /* ---------- 4. avisos de compra ----------
   *
   * Se barajan una vez y se recorren en orden, sin repetir hasta agotar la
   * lista. Sortear cada aviso por separado hace que el mismo nombre salga dos
   * veces seguidas, y eso lo delata al instante.
   *
   * Se cierra solo, se puede cerrar a mano, y si el visitante cierra uno no
   * vuelve a salir ninguno en toda la visita: insistir despues de que alguien
   * dijo que no es la forma mas rapida de que cierre la pestana entera.
   */
  function avisos() {
    var caja = document.querySelector('[data-avisos]');
    if (!caja || caja.dataset.listo) return;
    caja.dataset.listo = '1';

    var datos = [];
    try { datos = JSON.parse(caja.getAttribute('data-avisos') || '[]'); } catch (e) {}
    if (!datos.length) return;

    var primero = (parseFloat(caja.dataset.primero) || 12) * 1000;
    var cada = (parseFloat(caja.dataset.cada) || 11) * 1000;
    var dura = (parseFloat(caja.dataset.dura) || 6) * 1000;
    var foto = caja.dataset.foto || '';
    var cerrado = false;

    /* baraja de Fisher-Yates */
    for (var i = datos.length - 1; i > 0; i--) {
      var j = Math.floor(Math.random() * (i + 1));
      var t = datos[i]; datos[i] = datos[j]; datos[j] = t;
    }

    var k = 0;

    function muestra() {
      if (cerrado) return;
      var d = datos[k % datos.length];
      k++;

      var el = document.createElement('div');
      el.className = 'aviso bisel';
      el.setAttribute('role', 'status');
      el.innerHTML =
        (foto ? '<span class="aviso__img"><img src="' + foto + '" alt="" loading="lazy"></span>' : '') +
        '<span class="aviso__txt">' +
          '<span class="aviso__q"><b>' + d.n + '</b> ' + d.a + '</span>' +
          '<span class="aviso__p">' +
            '<svg class="aviso__ok" width="11" height="11" viewBox="0 0 12 12" fill="none" aria-hidden="true">' +
              '<path d="M2 6.2l2.6 2.6L10 3.4" stroke="currentColor" stroke-width="1.7"/></svg>' +
            d.t +
          '</span>' +
        '</span>' +
        '<button class="aviso__x" type="button" aria-label="Cerrar aviso">&times;</button>';

      caja.appendChild(el);
      requestAnimationFrame(function () { requestAnimationFrame(function () { el.classList.add('ver'); }); });

      var reloj = setTimeout(quita, dura);
      function quita() {
        clearTimeout(reloj);
        el.classList.remove('ver');
        setTimeout(function () { el.remove(); }, 340);
      }
      el.querySelector('.aviso__x').addEventListener('click', function () {
        cerrado = true;
        quita();
      });

      setTimeout(muestra, dura + cada);
    }

    setTimeout(muestra, primero);
  }

  function arranca() { barraOferta(); viendo(); stock(); avisos(); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', arranca);
  } else { arranca(); }

  /* El editor de Shopify recarga secciones sueltas. Cada pieza lleva su marca
   * data-listo, asi que volver a llamar no duplica intervalos ni avisos. */
  document.addEventListener('shopify:section:load', arranca);
})();
